/* "Passer i samme rom" — same-footprint battery alternatives on the PDP.
 * Same data source and card conventions as battery-finder.js: filters
 * battery-finder-data.json (same voltage + chemistry, each dim <= current
 * +2mm, not self), available first then closest capacity, top 4 cards with
 * lazy live price from /products/{handle}.js (404 removes the card).
 * The whole section stays hidden when no alternative qualifies. */
(function () {
  'use strict';

  var root = document.getElementById('pv-sf');
  if (!root) return;

  var SV = document.documentElement.lang === 'sv';
  var TOL = 2;
  var MAX = 4;
  var cur = {
    handle: root.dataset.handle,
    voltage: parseInt(root.dataset.voltage, 10),
    chem: root.dataset.chem,
    ah: parseFloat(root.dataset.ah) || null,
    l: parseInt(root.dataset.l, 10),
    w: parseInt(root.dataset.w, 10),
    h: parseInt(root.dataset.h, 10),
    available: root.dataset.available === 'true'
  };

  fetch(root.dataset.jsonUrl, { cache: 'no-cache' })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(function (data) {
      var list = (data.batteries || []).filter(function (b) {
        // footprint: rotation is allowed — the alternative fits if its l/w
        // fit the slot either way around (height stays height)
        var fits = (b.l <= cur.l + TOL && b.w <= cur.w + TOL)
                || (b.l <= cur.w + TOL && b.w <= cur.l + TOL);
        return b.handle !== cur.handle
          && b.voltage === cur.voltage
          && b.chem === cur.chem
          && fits && b.h <= cur.h + TOL;
      }).sort(function (a, b) {
        if (a.available !== b.available) return a.available ? -1 : 1;
        var da = cur.ah ? Math.abs(a.ah - cur.ah) : 0;
        var db = cur.ah ? Math.abs(b.ah - cur.ah) : 0;
        return da - db;
      }).slice(0, MAX);
      if (!list.length) return; // section stays hidden
      document.getElementById('pv-sf-heading').textContent = cur.available
        ? (SV ? 'Passar på samma plats' : 'Passer i samme rom')
        : (SV ? 'Slut i lager? Dessa passar på samma plats' : 'Utsolgt? Disse passer i samme rom');
      var grid = document.getElementById('pv-sf-grid');
      list.forEach(function (b) { grid.appendChild(card(b)); });
      root.hidden = false;
      observe(grid);
    })
    .catch(function () { /* leave hidden */ });

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function card(b) {
    var li = document.createElement('li');
    li.className = 'pv-bf__item card-wrapper';
    li.dataset.handle = b.handle;
    var badges = '';
    if (!b.available) badges += '<span class="pv-bf__badge pv-bf__badge--oos">' + (SV ? 'Slut i lager' : 'Utsolgt') + '</span>';
    if (b.b2b) badges += '<span class="pv-bf__badge pv-bf__badge--b2b">' + (SV ? 'Endast företag' : 'Kun bedrift') + '</span>';
    var specs = [b.voltage + 'V', (b.ah % 1 === 0 ? b.ah : String(b.ah).replace('.', ',')) + ' Ah',
                 b.chem, b.l + '×' + b.w + '×' + b.h + ' mm'];
    li.innerHTML =
      '<div class="card pv-bf__card">' +
        '<a class="pv-bf__cardlink full-unstyled-link" href="/products/' + b.handle + '">' +
          '<div class="pv-bf__media">' +
            (b.img ? '<img src="' + b.img + '" loading="lazy" alt="" width="180" height="180">' : '') +
            badges +
          '</div>' +
          '<div class="card__content pv-bf__content">' +
            '<h3 class="card__heading pv-bf__title">' + esc(b.title) + '</h3>' +
            '<div class="tech-badge-container">' +
              specs.map(function (t) { return '<span class="tech-badge-item">' + esc(t) + '</span>'; }).join('') +
            '</div>' +
            '<div class="pv-bf__price" data-price>&nbsp;</div>' +
          '</div>' +
        '</a>' +
      '</div>';
    return li;
  }

  function observe(grid) {
    var load = function (el) {
      var slot = el.querySelector('[data-price]');
      fetch('/products/' + el.dataset.handle + '.js')
        .then(function (r) {
          if (r.status === 404) { el.remove(); return null; }
          return r.ok ? r.json() : null;
        })
        .then(function (p) {
          if (!p || !slot) return;
          slot.innerHTML = '<strong>' + Math.round(p.price / 100).toLocaleString(SV ? 'sv-SE' : 'nb-NO') +
                           ' kr</strong> <small>' + (SV ? 'inkl. moms' : 'inkl. mva') + '</small>';
          // live availability corrects the week-old JSON flag both ways
          var badge = el.querySelector('.pv-bf__badge--oos');
          if (!p.available && !badge) {
            var b = document.createElement('span');
            b.className = 'pv-bf__badge pv-bf__badge--oos';
            b.textContent = SV ? 'Slut i lager' : 'Utsolgt';
            el.querySelector('.pv-bf__media').appendChild(b);
          } else if (p.available && badge) {
            badge.remove();
            el.classList.remove('pv-bf__item--oos');
          }
        })
        .catch(function () {});
    };
    if (!('IntersectionObserver' in window)) {
      grid.querySelectorAll('.pv-bf__item').forEach(load);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.unobserve(e.target); load(e.target); }
      });
    }, { rootMargin: '200px' });
    grid.querySelectorAll('.pv-bf__item').forEach(function (el) { io.observe(el); });
  }
})();
